export default __webpack_public_path__ + "static/media/succulent3-big.939d42f9.jpg";